var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "391.693px",
    height: "455.351px",
    viewBox: "0 -63.649 391.693 455.351",
    enableBackground: "new 0 -63.649 391.693 455.351",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E10092",
    stroke: "#E10092",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    d: "M6.58,187.039h271.406l-57.992-57.992 l13.918-13.919l81.188,81.189l-81.188,81.19l-13.918-13.918l57.992-57.992H6.58V187.039z M387.593,309.985V83.812 c0-42.914-34.796-77.71-77.71-77.71H83.71C40.795,6.102,6,40.898,6,83.812v46.396h19.138V83.812 c0-32.475,26.099-58.572,58.573-58.572h226.172c32.476,0,58.573,26.097,58.573,58.572v226.174c0,32.476-26.099,58.572-58.573,58.572 H83.71c-32.475,0-58.573-26.097-58.573-58.572v-45.814H6v45.814c0,42.914,34.796,77.709,77.71,77.709h226.172 C352.218,388.274,387.593,352.899,387.593,309.985z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.8f1e020715babea69e2b565624c3f75e.svg";
export { ForwardRef as ReactComponent };